import React from 'react';
import PropTypes from 'prop-types';

import {
  OptionListContainer,
  OptionContainer,
  Option,
  CircularCheckmark,
  UnclickedCircle,
  Text,
} from './OptionList.styles';

const OptionList = ({ answers, chosenAnswer, chooseAnswer }) => {
  const options = answers.map((answer) => {
    const selected = chosenAnswer === answer.id;
    return (
      <OptionContainer key={ answer.id } >
        <Option
          value={ answer.id }
          selected={ selected }
          onClick={ chooseAnswer }
        >
          <Text>{ answer.content }</Text>
          { selected
            ? (<CircularCheckmark> &#10003; </CircularCheckmark>)
            : <UnclickedCircle />
          }
        </Option>
      </OptionContainer>
    );
  });

  return (
    <OptionListContainer>
      { options }
    </OptionListContainer>
  );
};

OptionList.propTypes = {
  answers: PropTypes.array,
  chosenAnswer: PropTypes.number,
  chooseAnswer: PropTypes.func,
};

export default OptionList;
